import React from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import addQueryString from '@Utils/addQueryString';
import { TableHeader } from '@Features/generics/generics.type';
import TableSortLabel from '@mui/material/TableSortLabel';

interface Props {
	head: string | TableHeader;
	setSortBy: any;
	sortBy: any;
	renderCustomHeads?: boolean;
	customHead?: string;
	canSort?: boolean;
	showArrow?: boolean;
}

// Sort state is DERIVED from the shared `sortBy` (owned by MainTable, which
// hydrates it from the ?field&direction URL params). No local per-column
// state: the old SORTING enum desynced across columns, showed inverted
// arrows, and its per-instance URL-sync effect fired a redundant setSortBy
// from every column on each URL change.
const SortingIcons: React.FC<Props> = ({
	head,
	setSortBy,
	sortBy,
	customHead,
	canSort = true,
	renderCustomHeads,
}) => {
	const location = useLocation();
	const history = useHistory();

	const _field = typeof head === 'object' ? head.fieldName : head;
	const sortable =
		canSort &&
		!(typeof head === 'object' && head.canSort === false) &&
		typeof _field === 'string' &&
		_field.trim() !== '';
	const isActive = sortable && sortBy?.field === _field;
	const direction: 'asc' | 'desc' =
		isActive && sortBy?.direction === 'desc' ? 'desc' : 'asc';

	const clickHandler = () => {
		if (!sortable) return;
		let search = addQueryString(location.search, 'field', _field as string);
		if (!isActive) {
			setSortBy({ field: _field, direction: 'asc' });
			search = addQueryString(search, 'direction', 'asc');
		} else if (sortBy?.direction === 'asc') {
			setSortBy({ field: _field, direction: 'desc' });
			search = addQueryString(search, 'direction', 'desc');
		} else {
			setSortBy(null);
			search = addQueryString(search, 'direction', '');
			search = addQueryString(search, 'field', '');
		}
		history.push({ search });
	};

	const getHeader = () => {
		if (typeof head === 'object') return head.displayName;
		return head;
	};

	if (head !== 'Actions') {
		return (
			<TableSortLabel
				onClick={clickHandler}
				active={isActive}
				direction={direction}
				hideSortIcon={!sortable}
			>
				{renderCustomHeads ? customHead : getHeader()}
			</TableSortLabel>
		);
	} else {
		return null;
	}
};
export default SortingIcons;
